var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export function listSchematic(child) {
    return function (vars) {
        return new ListSchematicImplementation(child(vars));
    };
}
var ListSchematicImplementation = /** @class */ (function () {
    function ListSchematicImplementation(child) {
        this.child = child;
    }
    ListSchematicImplementation.prototype.chunk = function (input) {
        var _this = this;
        var _a = __read(input
            .map(function (inputItem) { return _this.child.chunk(inputItem); })
            .reduce(function (_a, item) {
            var _b = __read(_a, 2), chunks = _b[0], selections = _b[1];
            return [
                chunks.concat(item.chunks),
                selections.concat([item.selection]),
            ];
        }, [[], []]), 2), chunks = _a[0], selection = _a[1];
        return {
            chunks: chunks,
            selection: selection,
        };
    };
    ListSchematicImplementation.prototype.build = function (selection, pick) {
        var _this = this;
        var results = selection.map(function (item) { return _this.child.build(item, pick); });
        var primed = results.every(function (result) { return result.primed; });
        if (!primed) {
            return {
                pending: true,
                primed: false,
            };
        }
        var invalidated = results.some(function (result) { return result.invalidated; });
        var pending = results.some(function (result) { return result.pending; });
        var rejectionIndex = results.findIndex(function (result) { return result.hasRejection; });
        if (rejectionIndex !== -1) {
            return {
                hasRejection: true,
                invalidated: invalidated,
                pending: pending,
                primed: true,
                rejection: results[rejectionIndex].rejection,
            };
        }
        var hasData = results.every(function (result) { return result.hasData; });
        if (hasData) {
            return {
                hasData: true,
                invalidated: invalidated,
                pending: pending,
                primed: true,
                data: results.map(function (result) { return result.data; }),
            };
        }
        return {
            hasData: false,
            hasRejection: false,
            invalidated: false,
            pending: false,
            primed: true,
        };
    };
    return ListSchematicImplementation;
}());
//# sourceMappingURL=listSchematic.js.map